import styled from "styled-components";
import { Text } from "@chakra-ui/react"

export const StyledFooterTitle = styled(Text)`
    text-transform: uppercase;
    margin: 3rem 0rem;
    letter-spacing: 0.1rem;
`
